import { useContext } from 'react';
import { RbacContext, RbacState } from './RbacContext';
import {
  RbacPermission,
  RbacRole,
} from '../../plugins/infrastructure/rbacTypes';

export function useRbac(): RbacState {
  const ctx = useContext(RbacContext);
  if (!ctx) {
    throw new Error('useRbac must be used within an RbacProvider');
  }
  return ctx;
}

/**
 * Whether the current user holds a permission. Returns `undefined` while the
 * role is still loading so callers can distinguish "not yet known" from "denied".
 */
export function useHasPermission(
  permission: RbacPermission,
): boolean | undefined {
  const { permissions, loading } = useRbac();
  if (loading) return undefined;
  return permissions.includes(permission);
}

export function useHasRole(role: RbacRole): boolean | undefined {
  const { role: current, loading } = useRbac();
  if (loading) return undefined;
  return current === role;
}
